var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPulldown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 7,
    viewBox: "0 0 13 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.74219 6.64453L0.273438 1.17578C0 0.929688 0 0.519531 0.273438 0.246094C0.519531 0 0.929688 0 1.20312 0.246094L6.20703 5.25L11.2109 0.246094C11.457 0 11.8672 0 12.1133 0.246094C12.3867 0.492188 12.3867 0.929688 12.1133 1.17578L6.64453 6.64453C6.39844 6.89062 5.98828 6.89062 5.74219 6.64453Z",
    fill: "#404F69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulldown);
export default __webpack_public_path__ + "static/media/Pulldown.79fe8fd2f95b13c21ee2470d72af792c.svg";
export { ForwardRef as ReactComponent };